export default "__VITE_ASSET__DwfO1Hot__"